// extracted by mini-css-extract-plugin
export default {"navbar":"style_navbar__pKLNa","list":"style_list__JFpOA","item":"style_item__J+by1"};